<template>
  <div>
    <nav class="xl:w-4/6 md:w-9/12 sm:w-11/12 mx-auto">
      <ul class="flex space-x-3">
        <li>
          <router-link to="/careers">Careers</router-link>
        </li>
        <li>
          <router-link to="/news">Media</router-link>
        </li>
      </ul>
    </nav>

    <!-- <Login /> -->
  </div>
</template>

<script>
import Login from "../components/Login.vue";

export default {
  name: "Subheader",

  components: {
    Login,
  },
};
</script>
